module.exports = __webpack_public_path__ + "static/gm-24-9b7ff59ee7d77292efb25e4c8e41c1c4.jpg";